var _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#496E2D"
    },
    d: "M306.087,507.087c101.203-20.076,180.924-99.798,201-201h-201V507.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#496E2D"
    },
    d: "M4.913,306.087c20.075,101.202,99.797,180.924,201,201v-201H4.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#496E2D"
    },
    d: "M507.087,205.913c-20.076-101.202-99.797-180.924-201-201v201H507.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#496E2D"
    },
    d: "M205.913,4.913c-101.203,20.076-180.925,99.798-201,201h201V4.913z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M239.304,306.087h-33.391v201c10.897,2.161,22.044,3.625,33.391,4.356V306.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M239.304,205.913V0.557c-11.347,0.73-22.495,2.195-33.391,4.356v201H239.304z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272.696,0.557C267.174,0.2,261.611,0,256,0s-11.174,0.2-16.696,0.557v205.357h33.391V0.557z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M239.304,511.443C244.826,511.8,250.389,512,256,512s11.174-0.2,16.696-0.557V306.087h-33.391V511.443z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M205.913,239.304v-33.391h-201c-2.162,10.898-3.626,22.044-4.356,33.391H205.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M306.087,239.304h205.357c-0.73-11.347-2.195-22.493-4.356-33.391h-201V239.304z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M306.087,272.696h205.357C511.8,267.175,512,261.611,512,256s-0.2-11.175-0.557-16.696H306.087V272.696z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.557,239.304C0.201,244.825,0,250.389,0,256s0.201,11.175,0.557,16.696h205.357v-33.391H0.557z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D80027"
    },
    cx: 256,
    cy: 256,
    r: 122.435
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#496E2D"
    },
    d: "M283.894,269.66c-9.107-18.213-20.944-36.673-20.944-36.673s0.294-8.405,0.294-13.413 c0-7.544-6.116-13.66-13.66-13.66c-7.147,0-13.003,5.491-13.6,12.482c-5.62,0.367-10.067,5.029-10.067,10.741 c0,4.153,2.353,7.752,5.797,9.551c1.712-4.004,5.064-7.13,9.21-8.555c0.676,0.553,1.402,1.047,2.177,1.466l1.75,0.838 c0,0-6.489,18.291-6.489,28.117c0,27.624,18.214,36.143,18.214,36.143v0.285l-9.107,9.106h18.213v-18.214l9.107,9.107 C274.869,296.81,292.039,285.951,283.894,269.66z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "256,155.826 260.144,168.58 273.554,168.58 262.705,176.463 266.85,189.217 256,181.335  245.15,189.217 249.295,176.463 238.446,168.58 251.856,168.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "197.12,174.958 207.968,182.841 218.818,174.957 214.674,187.713 225.524,195.594  212.113,195.595 207.969,208.349 203.824,195.595 190.414,195.594 201.263,187.711  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "160.729,225.045 174.138,225.045 178.283,212.291 182.427,225.045 195.838,225.044  184.989,232.928 189.134,245.682 178.283,237.799 167.434,245.681 171.577,232.927  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "160.729,286.955 171.577,279.074 167.433,266.319 178.283,274.202 189.133,266.319  184.989,279.073 195.839,286.956 182.427,286.957 178.283,299.71 174.138,286.955  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "197.12,337.042 201.263,324.29 190.413,316.407 203.824,316.407 207.969,303.652  212.113,316.406 225.524,316.406 214.674,324.29 218.818,337.043 207.968,329.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "256,356.174 251.856,343.422 238.446,343.422 249.295,335.538 245.15,322.784 256,330.665  266.849,322.783 262.705,335.538 273.554,343.421 260.144,343.422  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "314.88,337.042 304.032,329.16 293.183,337.044 297.326,324.29 286.476,316.407  299.887,316.406 304.03,303.652 308.176,316.407 321.586,316.407 310.737,324.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "351.271,286.955 337.862,286.955 333.717,299.71 329.573,286.957 316.161,286.957  327.011,279.073 322.866,266.32 333.717,274.202 344.565,266.32 340.423,279.074  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "351.271,225.045 340.423,232.927 344.566,245.681 333.717,237.799 322.867,245.683  327.011,232.928 316.161,225.046 329.573,225.044 333.716,212.292 337.862,225.045  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "314.88,174.958 310.737,187.711 321.586,195.594 308.176,195.594 304.032,208.349  299.887,195.595 286.476,195.596 297.326,187.711 293.182,174.959 304.032,182.84  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDm);
export default __webpack_public_path__ + "static/media/dm.73a87d984cadf435fee4381f730550f4.svg";
export { ForwardRef as ReactComponent };